import { styles } from "./form";
import { colors } from "../utils/const";
import { Formik, useFormik } from "formik";
import {
  EnMortgageSchema,
  EnSchema,
  EnSchemaA,
  EnSchemaB,
} from "../utils/en_schema";
import {
  ArMortgageSchema,
  ArSchema,
  ArSchemaA,
  ArSchemaB,
} from "../utils/ar_schema";
import {
  Box,
  TextField,
  InputLabel,
  MenuItem,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useRouter } from "next/router";
import en from "../../locales/en";
import ar from "../../locales/ar";
import { api } from "../utils/Axios";
import { arFont, enFont } from "@/styles/font";
import React, { useEffect, useState } from "react";
import CIcon from "@coreui/icons-react";
import UAE_Files from "./UAE_Files";
import Terms_and_condation_form from "./terms-and-condation-form";

export default function Form({ type, color, product, source }) {
  // your reference => t.home_page.products.map((option)=> option.value)
  const isContactNow = product === "shopping";
  const router = useRouter();
  const { locale } = router;
  const t = locale === "en" ? en : ar;
  const [country, setCountry] = useState(
    product != "leasing" && product != "factoring"
      ? t.country[0].country_name
      : ""
  );
  const [phoneCode, setPhoneCode] = useState(locale === "en" ? "+20" : "+٢٠");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [passportUrl, setPassportUrl] = useState(null);
  const [WorkPermit, setWorkPermit] = useState(null);
  const [hrLetter, sethrLetter] = useState(null);
  const [bankStatement, setbankStatement] = useState(null);
  const [clearFileNames, setClearFileNames] = useState(false);
  const [upload, setUpload] = useState(false);

  const [URL, setURL] = useState("");

  const resetFiles = () => {
    setbankStatement(null);
    setWorkPermit(null);
    sethrLetter("");
    setPassportUrl(null);
  };

  const handleCountryChange = (event) => {
    values.mobilePhone = "";
    const selectedCountry = event.target.value;
    if (selectedCountry === "Egypt") {
      resetFiles();
    }

    const countryData = t.country.find((c) => c.id === selectedCountry);

    // Reset governance value when country changes
    handleChange({
      target: {
        name: "governance",
        value: countryData?.flag == "EG" ? "" : "default",
      },
    });
    // setFieldValue("governance", "default"); // Use setFieldValue

    setCountry(selectedCountry);

    setPhoneCode(countryData ? countryData?.phoneCode : "");
  };
  const handlePhoneCodeChange = (event) => {
    // values.governance = "";
    values.mobilePhone = "";

    const selectedCode = event.target.value;

    if (selectedCode === "+20") {
      resetFiles();
    }
    const countryData = t.country.find((c) => c.phoneCode === selectedCode);
    handleChange({
      target: {
        name: "governance",
        value: countryData?.flag == "EG" ? "" : "default",
      },
    });
    setCountry(countryData?.country_name);
    setPhoneCode(selectedCode);
  };

  const defaultValues = {
    //* old
    mobilePhone: "", //mandatory
    email: "", //mandatory
    name: "",
    homePhone: "",
    homeAddress: "",
    governance: "",
    area: "",
    carCondition: "",
    insuranceType: "",
    brand: "Brand",
    model: "",
    modelYear: "",
    buyerEmail: "",
    buyerName: "",
    buyerPhone: "",
    refName: "",
    refIdNo: "",
    refPhoneNumber: "",
    refProduct: "",
    needHelp: false,
    plan: "",
    category: "",
    refIdNumber: "",
    tenor: "0",
    amount: "0",
    downPayment: "0",
    installmentValue: "0",
    hrLetter: "",
    electricityBill: "",
    mortgageType: "",
    eCommerce: "", // yes/no
    commercialTax: "", // yes/no
    //* newly added
    electricityBill: "",
    propertyGovern: "",
    businessName: "",
    noOfEmployees: "0",
    businessIndustry: "",
    companyName: "",
    siteLink: "",
    noOfBranches: "0",
    POS: "",
    ////UAE
    passportUrl: passportUrl,
    workPermitUrl: WorkPermit,
    bankStatementUrl: bankStatement,
    hrLetter: hrLetter,
    EgyptAddress: "",
  };
  const gtag_report_conversion = (url) => {
    var callback = function () {
      return;
      // if (typeof url != "undefined") {
      //   window.location = url;
      // }
    };
    gtag("event", "conversion", {
      send_to: "AW-16652136146/WpbzCIGartkZENLdrYQ-",
      event_callback: callback,
    });
    return false;
  };

  const onSubmit = async (values, actions) => {
    try {
      const selectedCountry = t.country.find((c) => c.id === country);
      const formSource = selectedCountry?.flag == "EG" ? source : 45;
      let code;

      if (selectedCountry?.flag == "AE") {
        code = "+971";
      } else if (selectedCountry?.flag == "EG") {
        code = "+20";
      } else {
        code = "+2";
      }
      const formattedMobilePhone = code + values.mobilePhone;
      const response = await api.post(`/programs/${product}/info-request`, {
        ...defaultValues,
        ...values,
        passportUrl: passportUrl,
        workPermitUrl: WorkPermit,
        hrLetter: hrLetter ? hrLetter : null,
        bankStatementUrl: bankStatement,
        mobilePhone: formattedMobilePhone,
        formSource:
          product != "leasing" && product != "factoring" ? formSource : source,
      });

      // if (!response.status == 500) {
      toast.success(t.formMsg, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      actions.resetForm();
      setbankStatement(null);
      setWorkPermit(null);
      sethrLetter("");
      setPassportUrl(null);
      setClearFileNames(true);
      if (product != "leasing" && product != "factoring") {
        gtag_report_conversion(window?.location?.href);
      }
    } catch (error) {
      toast.error(t.formMsgFail, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      if (product != "leasing" && product != "factoring") {
        gtag_report_conversion(window?.location?.href);
      }
    }
  };
  let ArSchemaTest;
  let EnSchemaTest;
  let initialValuesTest;
  if (!type) {
    ArSchemaTest = ArSchema("product", country);
    EnSchemaTest = EnSchema("product", country);
    initialValuesTest = {
      name: "",
      // lastname: "",
      email: "",
      mobilePhone: "",
      // national_id: "",
      governance: "",
      // passportCopy: null,
      // workPermit: null,
      // hr_Letter: null,
      // bankStatement: null,
      // EgyptAddress:""

      // area: "",
    };
  } else if (type == "a") {
    ArSchemaTest = ArSchemaA("product", country);
    EnSchemaTest = EnSchemaA("product", country);
    initialValuesTest = {
      name: "",
      // lastname: "",
      email: "",
      mobilePhone: "",
      // national_id: "",
      governance: "",
      // area: "",
      // car_type: "",
      category: "",
      // car_price: "",
      amount: "",
      ////UAE

      passportUrl: passportUrl,
      workPermitUrl: WorkPermit,
      bankStatementUrl: bankStatement,
      hrLetter: hrLetter,
      EgyptAddress: "",
    };
  } else if (type == "b") {
    ArSchemaTest = ArSchemaB("product", country);
    EnSchemaTest = EnSchemaB("product", country);
    initialValuesTest = {
      name: "",
      // lastname: "",
      email: "",
      mobilePhone: "",
      // national_id: "",
      governance: "",
      // area: "",
      // products: "",
      products: product,
      ////UAE

      passportUrl: passportUrl,
      workPermitUrl: WorkPermit,
      bankStatementUrl: bankStatement,
      hrLetter: hrLetter,
      EgyptAddress: "",
    };
  } else if (type == "mortgage") {
    ArSchemaTest = ArMortgageSchema("product", country);
    EnSchemaTest = EnMortgageSchema("product", country);
    initialValuesTest = {
      name: "",
      email: "",
      mobilePhone: "",
      governance: "",
      products: product,
      mortgageType: "", //change depend on BE
      ////UAE
      passportUrl: passportUrl,
      workPermitUrl: WorkPermit,
      bankStatementUrl: bankStatement,
      hrLetter: hrLetter,
      EgyptAddress: "",
    };
  }

  const {
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    dirty,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    setFieldError,
  } = useFormik({
    initialValues: initialValuesTest,
    validationSchema: locale === "en" ? EnSchemaTest : ArSchemaTest,
    // EnSchemaTest,
    // validationContext: country, // Pass the countryCode here

    onSubmit,
  });
  return (
    <Box
      // data-aos={locale == "en" ? "fade-right" : "fade-left"}
      data-aos="fade-up"
      component="form"
      sx={{
        ...styles.container,
      }}
      onSubmit={handleSubmit}
      autoComplete="off"
      noValidate
    >
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        <InputLabel htmlFor="name" sx={styles.label}>
          {t.form_labels.full_name}
        </InputLabel>
        <TextField
          value={values.name}
          onChange={handleChange}
          id="name"
          type="text"
          onBlur={handleBlur}
          error={touched.name && errors.name}
          sx={styles.input}
          InputProps={{ sx: { height: "45px" } }}
          variant="outlined"
        />
        <Box sx={styles.helperText}>{touched.name && errors.name}</Box>
      </Box>
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        <InputLabel htmlFor="email" sx={styles.label}>
          {t.form_labels.email_adress}
        </InputLabel>
        <TextField
          value={values.email}
          onChange={handleChange}
          id="email"
          type="email"
          onBlur={handleBlur}
          error={touched.email && errors.email}
          sx={styles.input}
          InputProps={{ sx: { height: "45px" } }}
          variant="outlined"
        />
        <Box sx={styles.helperText}>{touched.email && errors.email}</Box>
      </Box>
      {product != "leasing" && product != "factoring" ? (
        <>
          <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
            <InputLabel htmlFor="country" sx={styles.label}>
              {" "}
              {t.form_labels.country}
            </InputLabel>

            <TextField
              value={country}
              onChange={handleCountryChange}
              name="country"
              id="country"
              select
              sx={styles.input}
              style={{ height: "45px" }}
              InputProps={{
                sx: {
                  height: "45px",
                  color: "grey",
                  lineHeight: "2",
                },
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      marginTop: 1,
                      maxHeight: 250,
                    },
                  },
                },
              }}
            >
              <MenuItem
                disabled
                value="default"
                className={locale == "en" ? enFont.className : arFont.className}
                sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
              >
                {t.form_labels.country_placeholder}
              </MenuItem>
              {t.country.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.country_name}
                  className={
                    locale == "en" ? enFont.className : arFont.className
                  }
                  sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                >
                  {option.country_name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </>
      ) : null}
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        <InputLabel htmlFor="mobilePhone" sx={styles.label}>
          {t.form_labels.phone_number}
        </InputLabel>
        {/* <Box sx={{ display: "flex", alignItems: "center" }}> */}

        <TextField
          value={values.mobilePhone}
          onChange={(event) => {
            const validInput = event.target.value.replace(/[^0-9]/g, "");
            if (
              validInput.length <= 10 &&
              country === t.country[0].country_name
            ) {
              event.target.value = validInput; // Update the event's value before passing it to handleChange
              handleChange(event);
            } else if (
              validInput.length <= 9 &&
              country === t.country[1].country_name
            ) {
              event.target.value = validInput; // Update the event's value before passing it to handleChange
              handleChange(event);
            } else if (
              validInput.length <= 11 &&
              (product == "leasing" || product == "factoring")
            ) {
              event.target.value = validInput; // Update the event's value before passing it to handleChange
              handleChange(event);
            }
            {
            }
          }}
          id="mobilePhone"
          // type="number"
          type="text"
          onBlur={handleBlur}
          placeholder={
            country === t.country[1].country_name
              ? t.country[1].country_name
              : t.country[0].country_name
          }
          error={touched.mobilePhone && errors.mobilePhone}
          sx={{ ...styles.input, pl: 0 }}
          // InputProps={{ sx: { height: "45px" } }}
          InputProps={{
            startAdornment:
              product != "leasing" && product != "factoring" ? (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    value={phoneCode}
                    onChange={handlePhoneCodeChange}
                    select
                    sx={{
                      // ...styles.input,
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        // width: "80px",
                        mt: 0.6,
                        // height: "50px",
                        bgcolor: "transparent",
                      },
                    }}
                  >
                    {t.country.map((option) => (
                      <MenuItem
                        key={option.phoneCode}
                        value={option.phoneCode}
                        className={
                          locale == "en" ? enFont.className : arFont.className
                        }
                        sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <CIcon
                            icon={option.icon}
                            style={{
                              width: "20px",
                              marginLeft: locale == "ar" ? "5px" : "0",
                              marginRight: locale == "en" ? "5px" : "0",
                            }}
                          />
                          {option.phoneCode}
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              ) : null,
            sx: { height: "45px" },
          }}
          // variant="outlined"
        />
        {/* </Box> */}

        <Box sx={styles.helperText}>
          {touched.mobilePhone && errors.mobilePhone}
        </Box>
      </Box>
      {/* Disclaimer - Display only if UAE is selected */}
      {country === t.country[1].country_name && (
        <Box
          sx={{
            backgroundColor: "#FFF2E6",
            borderRadius: "8px",
            padding: "8px",
            marginTop: "15px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            gap: "8px",
          }}
        >
          <InfoOutlinedIcon
            style={{
              color: "#FF8300",
            }}
          />
          <Typography variant="body2" sx={{ color: "#F18222" }}>
            {t.form_labels.Disclaimer}
          </Typography>
        </Box>
      )}
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        {(country === t.country[0].country_name ||
          product == "leasing" ||
          product == "factoring") && (
          <>
            <InputLabel sx={styles.label} htmlFor="governance">
              {t.form_labels.governorate}
            </InputLabel>
            <TextField
              value={values.governance || "default"}
              onChange={handleChange}
              name="governance"
              id="governance"
              type="text"
              onBlur={handleBlur}
              error={touched.governance && errors.governance}
              sx={styles.input}
              select
              style={{ height: "45px" }}
              InputProps={{
                sx: {
                  height: "45px",
                  color: "grey",
                  // fontWeight: "bold",
                  lineHeight: "2",
                },
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      marginTop: 1,
                      maxHeight: 250,
                    },
                  },
                },
              }}
            >
              <MenuItem
                disabled
                value="default"
                className={locale == "en" ? enFont.className : arFont.className}
                sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
              >
                {t.form_labels.g_placeholder}
              </MenuItem>
              {t.governorates.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.governorate_name}
                  className={
                    locale == "en" ? enFont.className : arFont.className
                  }
                  sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                >
                  {option.governorate_name}
                </MenuItem>
              ))}
            </TextField>
            <Box sx={styles.helperText}>
              {touched.governance && errors.governance}
            </Box>
          </>
        )}
      </Box>
      {type === "a" && (
        <>
          <Box sx={styles.inputWrapper} style={{ width: "250px" }}>
            <InputLabel htmlFor="category" sx={styles.label}>
              {t.form_labels.car_type}
            </InputLabel>
            <TextField
              // value={values.car_type || "default"}
              value={values.category || "default"}
              onChange={handleChange}
              // name="car_type"
              name="category"
              id="category"
              type="text"
              onBlur={handleBlur}
              // error={touched.car_type && errors.car_type}
              error={touched.category && errors.category}
              sx={styles.input}
              select
              style={{ height: "45px" }}
              InputProps={{
                sx: {
                  height: "45px",
                  color: "grey",
                  // fontWeight: "bold",
                  lineHeight: "2",
                },
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      marginTop: 1,
                      maxHeight: 250,
                    },
                  },
                },
              }}
            >
              <MenuItem
                disabled
                value="default"
                className={locale == "en" ? enFont.className : arFont.className}
                sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
              >
                {t.form_labels.car_placeholder}
              </MenuItem>
              {t.car_type.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.value}
                  className={
                    locale == "en" ? enFont.className : arFont.className
                  }
                  sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                >
                  {option.value}
                </MenuItem>
              ))}
            </TextField>
            <Box sx={styles.helperText}>
              {touched.category && errors.category}
            </Box>
          </Box>

          <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
            <InputLabel htmlFor="amount" sx={styles.label}>
              {t.form_labels.car_price}
            </InputLabel>
            <TextField
              value={values.amount}
              onChange={handleChange}
              id="amount"
              type="text"
              onBlur={handleBlur}
              error={touched.amount && errors.amount}
              sx={styles.input}
              InputProps={{ sx: { height: "45px" } }}
              variant="outlined"
            />
            <Box sx={styles.helperText}>{touched.amount && errors.amount}</Box>
          </Box>
        </>
      )}

      {type === "b" && <></>}
      {type === "mortgage" && (
        <>
          <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
            <InputLabel sx={styles.label}>
              {t.form_labels.mortgage_type}
            </InputLabel>
            <TextField
              value={values.mortgageType || "default"}
              onChange={handleChange}
              name="mortgageType"
              type="text"
              onBlur={handleBlur}
              error={touched.mortgageType && errors.mortgageType}
              sx={styles.input}
              select
              style={{ height: "45px" }}
              InputProps={{
                sx: {
                  height: "45px",
                  color: "grey",
                  lineHeight: "2",
                },
              }}
            >
              <MenuItem
                disabled
                value="default"
                className={locale == "en" ? enFont.className : arFont.className}
                sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
              >
                {t.form_labels.mortgage_type}
              </MenuItem>
              {t.mortgage_type.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.value}
                  className={
                    locale == "en" ? enFont.className : arFont.className
                  }
                  sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                >
                  {option.value}
                </MenuItem>
              ))}
            </TextField>
            <Box sx={styles.helperText}>
              {touched.mortgageType && errors.mortgageType}
            </Box>
          </Box>
        </>
      )}
      {country === t.country[1].country_name && (
        <>
          <UAE_Files
            styles={styles}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            touched={touched}
            setFieldError={setFieldError}
            errors={errors}
            t={t}
            phone={values.mobilePhone}
            values={values}
            setPassportUrl={setPassportUrl}
            setWorkPermit={setWorkPermit}
            sethrLetter={sethrLetter}
            setbankStatement={setbankStatement}
            clearFileNames={clearFileNames}
            setUpload={setUpload}
          />
          <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
            <InputLabel sx={styles.label}>
              {t.form_labels.EgyptAddress}
            </InputLabel>
            <TextField
              value={values.EgyptAddress}
              onChange={handleChange}
              id="EgyptAddress"
              type="EgyptAddress"
              onBlur={handleBlur}
              error={touched.EgyptAddress && errors.EgyptAddress}
              sx={styles.input}
              InputProps={{ sx: { height: "45px" } }}
              variant="outlined"
            />
            <Box sx={styles.helperText}>
              {touched.EgyptAddress && errors.EgyptAddress}
            </Box>
          </Box>

          <Box>
            <Terms_and_condation_form
              agreeTerms={agreeTerms}
              setAgreeTerms={setAgreeTerms}
            ></Terms_and_condation_form>
          </Box>
        </>
      )}
      <Button
        disabled={
          !!isSubmitting ||
          !isValid ||
          !dirty ||
          ((!agreeTerms || !upload) && country === t.country[1].country_name)
        }
        type="submit"
        aria-label="Form submit button "
        sx={styles.btn}
        style={{
          backgroundColor: isContactNow ? colors.orange : "#2D317F",
          border: `0px solid #74357D`,
        }}
      >
        {isSubmitting ? (
          <CircularProgress
            style={{ color: "#fff" }}
            size={25}
          ></CircularProgress>
        ) : (
          t.form_labels.submit
        )}
      </Button>
    </Box>
  );
}
